import { fabric } from 'fabric';
import { v4 as uuidv4 } from 'uuid';

export default class ImageCanvas {

  constructor(canvas, img) {
    this.canvas = canvas;
    this.img = img;
    this.addingRect = false;
    this.zoomRatio = null;
    this.fabricImageCanvas = this.buildCanvas();
    this.setUpEventListeners();
    this.rects = {}; // we need to keep records of the rect and text objects such that we can remove them if necessary
    this.nums = {};
    this.allowDragging = false;
    this.allowZoom = false;
    //this.currectActiveRect = null;
    this._events = {};
  }

  on(name, listener) {
    if (!this._events[name]) {
      this._events[name] = [];
    }

    this._events[name].push(listener);
  }

  removeListener(name, listenerToRemove) {
    if (!this._events[name]) {
      throw new Error(`Can't remove a listener. Event "${name}" doesn't exits.`);
    }
    const filterListeners = (listener) => listener !== listenerToRemove;
    this._events[name] = this._events[name].filter(filterListeners);
  }

  emit(name, data) {
    if (this._events[name]) {
      const fireCallbacks = (callback) => {
        callback(data);
      };
      this._events[name].forEach(fireCallbacks);        
    }
  }

  buildCanvas() {
    const hRatio = this.canvas.width / this.img.width;
    const vRatio = this.canvas.height / this.img.height;
    this.zoomRatio  = Math.min ( hRatio, vRatio );
    console.log("Inside fabric_builder.js, fabricBuilder, this.zoomRatio ==> ", this.zoomRatio);

    this.canvas.width = this.img.width * this.zoomRatio;
    this.canvas.height = this.img.height * this.zoomRatio;

    const fabricImg = new fabric.Image(this.img);
    const newCanvas = new fabric.Canvas(this.canvas);
    //const thisHandler = this;

    newCanvas.setBackgroundImage(fabricImg, newCanvas.renderAll.bind(newCanvas), {
      // Needed to position backgroundImage at 0/0
      originX: 'left',
      originY: 'top',
      // scaling
      scaleX: this.zoomRatio,
      scaleY: this.zoomRatio
    });
    
    return newCanvas;
  }

  setUpEventListeners() {
    const thisHandler = this;

    this.fabricImageCanvas.on({

      'mouse:down': function(opt) {
        console.log("canvas mouse:down, opt: ", opt);
        console.log("canvas mouse:down, absolutePointer: ", opt.absolutePointer.x, opt.absolutePointer.y);
        console.log("canvas mouse:down, this: ", this);
        const evt = opt.e;
        if ((evt.type == 'mousedown') || (evt.type == 'touchstart')) {
          let ox = opt.pointer.x;
          let oy = opt.pointer.y;
          
          console.log("canvas mouse:down, this.addingRect: ", thisHandler.addingRect);

          if (thisHandler.addingRect) {
            const xy = this.restorePointerVpt({x: ox, y: oy});
            const newRect = thisHandler.addRect(xy.x, xy.y);
            console.log("new Rect added, newRect ", newRect);
            thisHandler.addingRect = false; // we have successfully added a recr and no longer in addingRect state.
            thisHandler.emit("added_rect", newRect); // emit an event for the vue component to handle
          } else if (opt.target) {
            console.log('an object was clicked! ', opt.target.id);
            thisHandler.fabricImageCanvas.setActiveObject(opt.target);
          } else {
            console.log("canvas mouse:down, offsetX, offsetY: ", ox, oy);
            this.isDragging = true;
            this.selection = false;
            this.lastPosX = evt.clientX;
            this.lastPosY = evt.clientY;
          }
        }
      },

      'mouse:move': function(opt) {
        if ((this.isDragging) && (this.allowDragging)) {
          console.log("canvas mouse:move, opt: ", opt);
          const evt = opt.e;
          let clientX, clientY;
          if (evt.type == 'mousemove') {
            clientX = evt.clientX;
            clientY = evt.clientY;
          } else if (evt.type == "touchmove") {
            console.log("canvas mouse:move, evt.changedTouches[0] ", evt.changedTouches[0]);              
            clientX = evt.changedTouches[0].clientX;
            clientY = evt.changedTouches[0].clientY;
          }
          console.log("canvas mouse:move, clientX, clientY ", clientX, clientY);
          console.log("canvas mouse:move, this.lastPosX, this.lastPosY ", this.lastPosX, this.lastPosY);
          const hTranslation = (this.lastPosX ? clientX - this.lastPosX : 0);
          const vTranslation = (this.lastPosY ? clientY - this.lastPosY : 0);
          console.log("canvas mouse:move, hTranslation, vTranslation ", hTranslation, vTranslation);
          this.viewportTransform[4] += hTranslation; // holizontal translation
          this.viewportTransform[5] += vTranslation; // vertical translation
          this.requestRenderAll();
          this.lastPosX = clientX;
          this.lastPosY = clientY;
        }
      },

      'mouse:up': function(opt) {
        console.log("canvas mouse:up, opt: ", opt);
        console.log("canvas mouse:up, this: ", this);
        const evt = opt.e;
        if ((evt.type == 'mouseup') || (evt.type == 'touchend')) {
          this.isDragging = false;
          this.selection = true;
        }
      },

      'mouse:wheel': function(opt) {
        if (this.allowZoom) {
          console.log("canvas mouse:wheel, opt: ", opt);
          var delta = opt.e.deltaY;
          var zoom = this.fabricImageCanvas.getZoom();
          zoom = zoom + delta/600;
          if (zoom > 3) zoom = 3;
          if (zoom < 1) zoom = 1;
          this.fabricImageCanvas.setZoom(zoom);
          opt.e.preventDefault();
          opt.e.stopPropagation();
        }
      }

    });    
  }

  buildRect(args = {}) {

    const buildRectZoomRatio = this.zoomRatio / args.zoomRatio;

    console.log("Inside fabric_builder.js, buildRect, buildRectZoomRatio ==> ", buildRectZoomRatio);

    const rectParams = {
      id: args.uuid,
      left: args.left * buildRectZoomRatio,
      top: args.top * buildRectZoomRatio,
      fill: 'transparent',
      width: args.width,
      height: args.height,
      angle: args.angle,
      scaleX: (args.scaleX ? args.scaleX : 1.0) * buildRectZoomRatio,
      scaleY: (args.scaleY ? args.scaleY : 1.0) * buildRectZoomRatio,
      objectCaching: false,
      transparentCorners: true,
      cornerColor: 'blue',
      stroke: 'red',
      strokeWidth: 3,
      strokeDashArray: [10, 5],
      strokeUniform: true,
      cornerStyle: 'circle',
    }

    console.log("Inside fabric_builder.js, buildRect, rectParams ==> ", rectParams);

    // draw the rectangle
    const rect = new fabric.Rect(rectParams);
    this.fabricImageCanvas.add(rect);

    // show annotation number if there is one
    if (args.num) {
      const num_params = { 
        fontFamily: 'Nunito',
        left: rectParams.left - 10, 
        top: rectParams.top - 10,
        fontSize: 18,
        textAlign: "left",
        fill: "white",
        backgroundColor: "red"
      }
      const num_obj = new fabric.Text(" " + args.num.toString() + " ", num_params);
      this.fabricImageCanvas.add(num_obj);
      this.nums[args.uuid] = num_obj;
    }

    const thisHandler = this;
    rect.on('mouseover', function() {
      console.log("This object mouseover", this);
      this.set('strokeWidth', 6);
    });

    rect.on('mouseout', function() {
      console.log("This object mouseout", this);
      this.set('strokeWidth', 3);
    });

    rect.on('mousedblclick', function() {
      console.log("This object mousedblclick ==> ", this.id);
      thisHandler.emit("dblclicked_rect", this.id);
    });

    rect.on('moved', function() {
      console.log("This object moved, this.top ==> ", this.top);
      console.log("This object moved, this.left ==> ", this.left);
      thisHandler.emit("moved_rect", this.id);
    });

    rect.on('rotated', function() {
      console.log("This object rotated, this.angle ==> ", this.angle);
      thisHandler.emit("rotated_rect", this.id);
    });
    
    rect.on('scaled', function() {
      console.log("This object scaled, this.scaleX ==> ", this.scaleX);
      console.log("This object scaled, this.scaleY ==> ", this.scaleY);
      thisHandler.emit("scaled_rect", this.id);
    });

    this.rects[rect.id] = rect;
    
    return rect;
  }

  addRect(x, y, id) {
    if (!id) {
      id = uuidv4(); 
    }

    const rect = this.buildRect({
      uuid: id,
      left: x - 50,
      top: y - 50,  
      width: 100,
      height: 100,
      scaleX: 1.0,
      scaleY: 1.0,
      angle: 0,
      zoomRatio: this.zoomRatio // whatever the zoom level is of the background image, when we are adding the rect, we follow the scale at that moment, hence the zoom level is always 1
    });

    return rect;
  }

  getRect(id) {
    return this.rects[id];
  }

  getNumObj(id) {
    return this.nums[id];
  }

  activeRect() {
    return this.fabricImageCanvas.getActiveObject();
  }

  setActiveRect(rectUUID) {
    const rect = this.getRect(rectUUID)
    console.log("Inside fabric_builder.js, setActiveRect, rect ==> ", rect);
    this.fabricImageCanvas.setActiveObject(rect);
    this.fabricImageCanvas.requestRenderAll()
  }

  removeRect(rectId) {
    const rect = this.getRect(rectId);
    this.fabricImageCanvas.remove(rect);
    delete this.rects[rectId];
    const num_obj = this.getNumObj(rectId);
    if (num_obj) {
      this.fabricImageCanvas.remove(num_obj);
      delete this.nums[rectId];
    }
  }

  removeAllRects() {
    Object.keys(this.rects).forEach(function (rectId) {
      this.removeRect(rectId);
    }.bind(this));
  }

}